// removed by extract-text-webpack-plugin
module.exports = {"react-tabs":"react-tabs","react-tabs__tab-list":"react-tabs__tab-list","react-tabs__tab":"react-tabs__tab","react-tabs__tab--disabled":"react-tabs__tab--disabled","react-tabs__tab--selected":"react-tabs__tab--selected","tab-panel-content":"tab-panel-content","student-panel":"student-panel","btn":"btn","teacher-table":"teacher-table","finance-table":"finance-table","navigate-date":"navigate-date","btn-link":"btn-link","setting-dropdown":"setting-dropdown","dropdown":"dropdown","student-dropdown":"student-dropdown"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Tabs/Tabs.scss
// module id = 4UEG
// module chunks = 0